// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OGWg4wli2v3TAOs29Z75 {
  flex: 1;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: 100vh;
}

.OGWg4wli2v3TAOs29Z75 .vweMCB1YWAxNxTmoGKYO {
  background-color: #f7f7f7;
  border: 1px none;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.OGWg4wli2v3TAOs29Z75 .bUNZ5GkDzKZqeND0Yq_Q {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 300px;
}

.OGWg4wli2v3TAOs29Z75 .WuE7RoRWj7NxWYXYLuCP {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 4px;
  position: relative;
}

.OGWg4wli2v3TAOs29Z75 .Wom_88wnhWyT56YlqMzt {
  color: #000000;
  font-family: "Noto Sans-Bold", Helvetica;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 24px;
  position: relative;
  text-decoration: underline;
}

.OGWg4wli2v3TAOs29Z75 .bcFYlxxNS8T0KUi1IOZw {
  color: #33333380;
}

.OGWg4wli2v3TAOs29Z75 .hp7UQZxQZF_j_E6k7p_7 {
  color: #ed1b2e;
  font-weight: 700;
  text-decoration: unset;
}

.OGWg4wli2v3TAOs29Z75 .NxNv1obTjYMiWSerGky2 {
  color: #ffffff;
  font-family: "Open Sans-Bold", Helvetica;
  font-weight: 700;
}

.OGWg4wli2v3TAOs29Z75 .VP9OGfNlhbOzsJNF3QgI {
  align-items: flex-start;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 16px;
  position: relative;
}

.XF9047HallzjxGBlES8n {
  align-items: center;
  background-color: #ffffff;
  border-color: #f7f7f7;
  border-radius: 8px;
  display: flex;
  width: 44px;
  justify-content: center;
  align-items: center;
}

.p3Hro9cRJk4NN9qNTmDe {
  color: #333333;
  flex: 1;
  font-family: Noto Sans;
  font-size: 240px;
  font-weight: Bold;
  line-height: 32px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/login/Login.module.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,OAAO;EACP,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".container {\n  flex: 1;\n  background-color: #f7f7f7;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n  height: 100vh;\n}\n\n.container .div {\n  background-color: #f7f7f7;\n  border: 1px none;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.container .frame_3 {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 300px;\n}\n\n.container .frame_5 {\n  align-items: center;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 4px;\n  position: relative;\n}\n\n.container .kembali {\n  color: #000000;\n  font-family: \"Noto Sans-Bold\", Helvetica;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0;\n  line-height: 24px;\n  position: relative;\n  text-decoration: underline;\n}\n\n.container .span {\n  color: #33333380;\n}\n\n.container .text_wrapper_4 {\n  color: #ed1b2e;\n  font-weight: 700;\n  text-decoration: unset;\n}\n\n.container .text_wrapper_5 {\n  color: #ffffff;\n  font-family: \"Open Sans-Bold\", Helvetica;\n  font-weight: 700;\n}\n\n.container .nav {\n  align-items: flex-start;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 16px;\n  position: relative;\n}\n\n.number_box {\n  align-items: center;\n  background-color: #ffffff;\n  border-color: #f7f7f7;\n  border-radius: 8px;\n  display: flex;\n  width: 44px;\n  justify-content: center;\n  align-items: center;\n}\n\n.number_otp {\n  color: #333333;\n  flex: 1;\n  font-family: Noto Sans;\n  font-size: 240px;\n  font-weight: Bold;\n  line-height: 32px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OGWg4wli2v3TAOs29Z75`,
	"div": `vweMCB1YWAxNxTmoGKYO`,
	"frame_3": `bUNZ5GkDzKZqeND0Yq_Q`,
	"frame_5": `WuE7RoRWj7NxWYXYLuCP`,
	"kembali": `Wom_88wnhWyT56YlqMzt`,
	"span": `bcFYlxxNS8T0KUi1IOZw`,
	"text_wrapper_4": `hp7UQZxQZF_j_E6k7p_7`,
	"text_wrapper_5": `NxNv1obTjYMiWSerGky2`,
	"nav": `VP9OGfNlhbOzsJNF3QgI`,
	"number_box": `XF9047HallzjxGBlES8n`,
	"number_otp": `p3Hro9cRJk4NN9qNTmDe`
};
export default ___CSS_LOADER_EXPORT___;
